module.exports = __webpack_public_path__ + "img/icon_mail.57bfc26d.svg";